import './App.css';
import ImageGenerator from './Components/ImageGenerator/ImageGenerator.jsx';

function App() {
  return (
    <div>
      <ImageGenerator />

    </div>
  );
}

export default App;
